import { ReactElement } from "react";

export default function IconDWH(): ReactElement {
  return (
    <svg
      width="96"
      height="96"
      viewBox="0 0 96 96"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="96" height="96" rx="48" fill="#F3F3F4" />
      <path
        d="M48 63C54.6274 63 60 61.9152 60 60.5769V54.5C60 53.3954 59.1046 52.5 58 52.5H38C36.8954 52.5 36 53.3954 36 54.5V60.5769C36 61.9152 41.3726 63 48 63Z"
        fill="white"
        stroke="#92999E"
        strokeWidth="1.25"
      />
      <path
        d="M48 54C54.6274 54 60 52.9152 60 51.5769V45.5C60 44.3954 59.1046 43.5 58 43.5H38C36.8954 43.5 36 44.3954 36 45.5V51.5769C36 52.9152 41.3726 54 48 54Z"
        fill="white"
        stroke="#92999E"
        strokeWidth="1.25"
      />
      <path
        d="M48 45C54.6274 45 60 43.9152 60 42.5769V34.65C60 34.5672 59.9328 34.5 59.85 34.5H36.15C36.0672 34.5 36 34.5672 36 34.65V42.5769C36 43.9152 41.3726 45 48 45Z"
        fill="white"
        stroke="#92999E"
        strokeWidth="1.25"
      />
      <ellipse
        cx="48"
        cy="34.5"
        rx="12"
        ry="1.5"
        fill="white"
        stroke="#92999E"
        strokeWidth="1.25"
      />
      <circle cx="60" cy="57" r="10" fill="#74A73C" />
      <path
        d="M56 57H64"
        stroke="white"
        strokeWidth="1.25"
        strokeLinecap="round"
      />
      <path
        d="M60 53L60 61"
        stroke="white"
        strokeWidth="1.25"
        strokeLinecap="round"
      />
    </svg>
  );
}
